/**
 * FR-3.1..FR-3.3: Реестр source-specific конфигураций.
 * Точка входа для всех per-source компонентов.
 */
import { SourceConfig } from './types';
import { hhConfig } from './hh/config';
import { estaffConfig, skillazConfig } from './estaff/config';
import { avitoConfig } from './avito/config';

export { hhConfig } from './hh/config';
export { estaffConfig, skillazConfig } from './estaff/config';
export { avitoConfig, avitoSourceModule } from './avito';
export { avitoFilterAdapter, getSourceFilterAdapter } from './filterAdapters';
export type { SourceFilterAdapter, SearchQuery, SearchApiParams } from './filterAdapters';
export {
  applySourceVacancyFilters,
  getRegisteredSourceModules,
  getSourceModule,
  hasSourceVacancyMapper,
  mapSourceVacancyToFilters,
  normalizeSourceVacancyList,
} from './sourceModules';
export type {
  SourceFilterBucketId,
  SourceFilterModule,
  SourceModule,
  SourceSwitchParams,
  SourceTransferParams,
  SourceVacancyParams,
} from './sourceModules';
export type { SourceConfig, CandidatePayload, FilterSection, DictItem, DataLoaders, UiHints } from './types';

/** Реестр всех source configs по id */
const sourceRegistry: Record<string, SourceConfig> = {
  hh: hhConfig,
  estaff: estaffConfig,
  skillaz: skillazConfig,
  avito: avitoConfig,
};

/** Получить конфигурацию source по id */
export function getSourceConfig(sourceId: string): SourceConfig {
  return sourceRegistry[sourceId] || estaffConfig;
}

/** Получить маппер toPayload для source */
export function getSourceMapper(sourceId: string) {
  return getSourceConfig(sourceId).toPayload;
}

/** Получить enabledMessengers для source */
export function getSourceMessengers(sourceId: string): string[] {
  return getSourceConfig(sourceId).enabledMessengers;
}

/** Получить messengerPriority для source */
export function getSourcePriority(sourceId: string): string[] {
  return getSourceConfig(sourceId).messengerPriority;
}

/** Проверить доступна ли секция фильтров для source */
export function hasFilterSection(sourceId: string, section: string): boolean {
  return getSourceConfig(sourceId).filterSections.includes(section as any);
}

/** Получить подпись поля для source (с фоллбэком на дефолт) */
export function getFieldLabel(sourceId: string, fieldKey: string, defaultLabel: string): string {
  return getSourceConfig(sourceId).fieldLabels?.[fieldKey] ?? defaultLabel;
}

export default sourceRegistry;
